import React from 'react';
import classNames from 'classnames';
import style from './AccountId.module.css';
var AccountId = function AccountId(_ref) {
  var items = _ref.items,
    className = _ref.className;
  var classes = classNames(style.account, 'js-account-identification-details', className);
  return /*#__PURE__*/React.createElement("span", {
    className: classes
  }, items.map(function (item, key) {
    return /*#__PURE__*/React.createElement("span", {
      key: item,
      className: "js-item-".concat(key)
    }, item, ' ');
  }));
};
export default AccountId;